import React from 'react';
import PropTypes from 'prop-types';
import DataCard from 'components/common/card/DataCard';
import { PAYMENT_PROCESSOR } from 'utils/constants';
import { formatReadMethod } from 'utils/formatReadMethod';
import { formatDate, formatPaymentTime } from 'utils/formatTimestamp';
import { getPaymentTotalPaidText } from 'utils/formatters/getPaymentTotalPaidText';

export const Payments = ({ payments = [], onHeaderAction, isService }) => {
  // we want to show the payments in the order they were created
  const reversedPayments = [...payments].reverse();

  return reversedPayments.map((payment, index) => {
    const {
      id,
      status,
      paymentProcessor,
      paymentToken,
      totalAmount,
      createdAt,
      readMethod,
      orderPaymentAmount,
    } = payment;
    const title = `Payment #${index + 1}`;

    const getActionByPayment = () => {
      if (!isService) return {};

      const isStripePaymentCapturable =
        paymentProcessor === PAYMENT_PROCESSOR.STRIPE &&
        ['requires_confirmation', 'requires_capture'].includes(status);

      if (isStripePaymentCapturable) return { header: 'Capture Payment', actionType: 'CAPTURE' };

      return {};
    };

    const { header, actionType } = getActionByPayment();

    const totalPaidText = getPaymentTotalPaidText({
      totalAmount,
      orderPaymentAmount,
    });
    const stripePaymentToken = paymentProcessor === PAYMENT_PROCESSOR.STRIPE ? paymentToken : '';

    const details = [
      { label: 'Payment ID', data: id },
      { label: 'Payment Status', data: status },
      { label: 'Payment Date', data: formatDate(createdAt) },
      { label: 'Payment Time', data: formatPaymentTime(createdAt) },
      { label: 'Payment Processor', data: paymentProcessor },
      {
        label: 'Payment Token',
        data: stripePaymentToken,
        type: 'external-link',
        href: `https://dashboard.stripe.com/payments/${stripePaymentToken}`,
      },
      {
        label: 'Read Method',
        data: formatReadMethod(readMethod),
      },
      { label: 'Total Paid', data: totalPaidText },
    ];

    return (
      <DataCard
        key={title}
        title={title}
        cardData={details}
        headerActionTitle={header}
        headerAction={() => onHeaderAction?.(payment, actionType)}
      />
    );
  });
};

Payments.propTypes = {
  payments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      status: PropTypes.string,
      paymentProcessor: PropTypes.string,
      paymentToken: PropTypes.string,
      totalAmount: PropTypes.number,
      createdAt: PropTypes.string,
      readMethod: PropTypes.string,
    }),
  ),
  onHeaderAction: PropTypes.func,
  isService: PropTypes.bool,
};
